import { Box } from '@zoopla-eng/zds/box';
import { Skeleton } from '@zoopla-eng/zds/skeleton';
import {
    wave1Style,
    container1Style,
    container2Style,
    wave2Style,
    wave3Style
} from './HeaderSkeleton.styles.css';

export const HeaderSkeleton = () => (
    <Box>
        <div className={wave1Style}>
            <Skeleton.Wave
            // css={{ borderRadius: '8px' }}
            />
        </div>
        <div className={container1Style}>
            <div className={container2Style}>
                <div className={wave2Style}>
                    <Skeleton.Wave
                    // css={{ borderRadius: '8px' }}
                    />
                </div>
                <div className={wave2Style}>
                    <Skeleton.Wave
                    // css={{ borderRadius: '8px' }}
                    />
                </div>
            </div>
            <div className={container2Style}>
                <div className={wave3Style}>
                    <Skeleton.Wave
                    // css={{ borderRadius: '8px' }}
                    />
                </div>
            </div>
        </div>
    </Box>
);
